import { observable } from "mobx";
import { Type } from "class-transformer";
import TradingPlaceResponse from "./tradingPlaceResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TradingPlacesResponse {
  /**
   * The list of trading places (salespoints and kiosks).
   */
  @observable
  @Type(() => TradingPlaceResponse)
  items!: TradingPlaceResponse[];
}
